import validate from "/app/node_modules/.pnpm/nuxt@3.16.2_@parcel+watcher@2.5.1_@types+node@18.19.86_db0@0.3.1_encoding@0.1.13_eslint@8.57._dodylrhrl4rkex2mhf7qirzkcm/node_modules/nuxt/dist/pages/runtime/validate.js";
import redirects_45global from "/app/middleware/redirects.global.ts";
import trailing_45slash_45global from "/app/middleware/trailing-slash.global.ts";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.16.2_@parcel+watcher@2.5.1_@types+node@18.19.86_db0@0.3.1_encoding@0.1.13_eslint@8.57._dodylrhrl4rkex2mhf7qirzkcm/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  redirects_45global,
  trailing_45slash_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "auth-desktop": () => import("/app/middleware/auth-desktop.ts"),
  "check-token-landing": () => import("/app/middleware/checkTokenLanding.ts"),
  "home-redirect": () => import("/app/middleware/home-redirect.ts"),
  "is-authenticated": () => import("/app/middleware/is-authenticated.ts"),
  "prevent-my-devices-not-enabled": () => import("/app/middleware/preventMyDevicesNotEnabled.ts")
}